import Action from "../actions";

export default function storeManagementReducer(state = {
    viewList: {
        storeList:[],
        total:0
    },
    addNew: {},
    viewDetail: {}
}, action) {
    if (action.type === Action.SET_STORE_MANAGEMENT) {
        return action.data;
    }
    return state;
}
